import React from 'react';
import { useSelector } from 'react-redux';
import { seoStateSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import insertAnElementIntoArrayAtSpecificIndex from '@stencil/flights-utils/src/insert-an-element-into-array-at-specific-index';
import AboutCity from '@stencil/commonstories/src/components/Seo/about-city/about-city';
import AboutAirline from '@stencil/commonstories/src/components/Seo/about-city/about-airline';
// import RouteCard from '@stencil/dstories/src/components/SRP/SrpCard/seo-airline-route-card-ui';
import RouteCard from '@stencil/commonstories/src/components/Seo/route-cards/route-card-list';

const SeoAirlinesRight = props => {
  const seoState = useSelector(seoStateSelector);
  const {
    write_up,
    airlineInfo,
    cheapFareDomRoutes,
    cheapFareIntlRoutes,
    h_1_header,
    extraContent,
    extraContentPosition
  } = seoState;

  const {
    name: airlineName,
    about_airline: aboutAirline,
    airline_services_html: airlineServices,
    baggage_template_content: baggageTemplateContent,
    web_checkin_template_content: webCheckInTemplateContent,
    flight_schedule_template_content: flightScheduleTemplateContent,
    inflight_services: inflightServices,
    airline_history: airlineHistory
  } = airlineInfo;
  let routeInfoElements = [
    ...(aboutAirline
      ? [<AboutCity title={`About ${airlineName}`} longDesc={aboutAirline} isDweb={true} />]
      : []),
    ...(airlineServices
      ? [
          <AboutAirline
            title={`${airlineName} Operation`}
            longDesc={airlineServices}
            isDweb={true}
          />
        ]
      : []),
    ...(baggageTemplateContent
      ? [
          <AboutCity
            title={`${airlineName} Baggage Information`}
            longDesc={baggageTemplateContent}
            isDweb={true}
          />
        ]
      : []),
    ...(webCheckInTemplateContent
      ? [<AboutCity title={''} longDesc={webCheckInTemplateContent} isDweb={true} />]
      : []),
    ...(flightScheduleTemplateContent
      ? [<AboutCity title={''} longDesc={flightScheduleTemplateContent} isDweb={true} />]
      : []),
    ...(inflightServices
      ? [
          <AboutCity
            title={`${airlineName} Inflight Services`}
            longDesc={inflightServices}
            isDweb={true}
          />
        ]
      : []),
    ...(airlineHistory
      ? [<AboutCity title={`${airlineName} History`} longDesc={airlineHistory} isDweb={true} />]
      : [])
  ];
  routeInfoElements = extraContent
    ? insertAnElementIntoArrayAtSpecificIndex(
        routeInfoElements,
        extraContentPosition,
        <AboutCity title="" longDesc={extraContent} isDweb={true} />
      )
    : routeInfoElements;

  return (
    <>
      <AboutCity title={h_1_header} longDesc={write_up} isDweb={true} shouldBeH1={true} />
      <RouteCard
        routesList={cheapFareDomRoutes}
        airlineInfo={airlineInfo}
        type="Domestic"
        isDweb={true}
      />
      <RouteCard
        routesList={cheapFareIntlRoutes}
        airlineInfo={airlineInfo}
        type="International"
        isDweb={true}
      />
      {routeInfoElements.map((element, index) => {
        return <div key={index}>{element}</div>;
      })}
    </>
  );
};

export default SeoAirlinesRight;
